import "./testimonials.page.css"; // Retain legacy styles outside the modern shell.
import { testimonials } from "../../Data/TestimonialData";
import PageIntro from "../../Components/modern/PageIntro";
import { Container, Eyebrow } from "../../Components/modern/UI";

function StoryImage({ testimonial, featured = false }) {
  return <img src={testimonial.pic} alt={testimonial.name === "Durga Charan" ? "Customers with their agricultural machine, from Durga Charan’s story" : testimonial.name === "Sunil" ? "Machine in use in a maize field, from Sunil’s story" : `${testimonial.name}, ${testimonial.place}`} loading={featured ? "eager" : "lazy"} width="600" height="600" className="sn-photo sn-aspect-square sn-h-auto sn-w-full sn-rounded-card sn-object-cover sn-object-center" />;
}
export default function Testimonials() {
  const featured = testimonials.find((testimonial) => testimonial.name === "Ganganna") || testimonials[0];
  const remaining = testimonials.filter((testimonial) => testimonial !== featured);
  return (
    <>
      <PageIntro eyebrow="Farmer stories" title={<>Real work.<br />In their own words.</>}>
        Hear from the people using Suryanirbhar machines in their fields and poultry farms.
      </PageIntro>
      {featured && <section aria-labelledby="sn-featured-farmer" className="sn-py-12 md:sn-py-16">
        <Container className="sn-grid sn-gap-8 md:sn-grid-cols-[0.9fr_1.1fr] md:sn-items-center lg:sn-gap-16">
          <StoryImage testimonial={featured} featured />
          <div>
            <Eyebrow>From the field · {featured.place}</Eyebrow>
            <blockquote className="sn-m-0 sn-font-display sn-text-lg sn-leading-relaxed sn-text-forest lg:sn-text-xl"><p>{featured.message}</p></blockquote>
            <div className="sn-mt-6 sn-border-t sn-border-line sn-pt-5">
              <h2 id="sn-featured-farmer" className="sn-font-display sn-text-2xl sn-text-forest">{featured.name}</h2>
              <p className="sn-mt-1 sn-text-sm sn-text-muted">{featured.place}</p>
            </div>
          </div>
        </Container>
      </section>}
      <section aria-labelledby="sn-more-stories" className="sn-border-t sn-border-line sn-bg-white sn-py-12 md:sn-py-16">
        <Container>
          <h2 id="sn-more-stories" className="sn-section-title sn-font-display sn-text-forest">More voices from the ground.</h2>
          <div className="sn-mt-8 sn-grid sn-gap-10 md:sn-grid-cols-2 lg:sn-grid-cols-3 lg:sn-gap-8">
            {remaining.map((testimonial) => (
              <article key={testimonial.name} className="sn-flex sn-flex-col">
                <StoryImage testimonial={testimonial} />
                <h3 className="sn-mt-6 sn-font-display sn-text-2xl sn-text-forest">{testimonial.name}</h3>
                <p className="sn-mt-1 sn-text-sm sn-text-muted">{testimonial.place}</p>
                <blockquote className="sn-m-0 sn-mt-5 sn-text-base sn-leading-relaxed sn-text-muted"><p>{testimonial.message}</p></blockquote>
              </article>
            ))}
          </div>
        </Container>
      </section>
      {/* Temporarily hidden per client review; Customer Videos may be restored later.
      <CustomerVideos testimonials={[featured, ...remaining].filter(Boolean)} />
      */}
    </>
  );
}
